var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"ivu-icon ivu-icon-ios-help-circle-outline",staticStyle:{"cursor":"pointer"},attrs:{"title":_vm.text}})
}
var staticRenderFns = []

export { render, staticRenderFns }